import React, { useState, useRef, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import {fetchAuditUrl, logOut} from '../../utills';
import { useHistory } from 'react-router-dom';
import Button from 'jd-library/Button';
import {setLoggedUser} from '../../actions/index';
import styles from './auditor-success-page.scss';

const AuditSuccess = props => {
    const [auditLoader, updateAuditLoader] = useState(false);
    const [logoutLoader, updateLogoutLoader] = useState(false);
    let history = useHistory();
    return (
    <div className = {styles['audit-saved']}>
        <div className = {styles['holder']}>
            <div className = {styles['icon-holder']}>
                <i className = {styles['icon'] + ' ' + 'icon-Checkmark'}></i>
            </div>
            <div className = {styles['main-text']}>
                Audit Information Saved
            </div>
            <Button 
                showLoader = {auditLoader}
                size="lg"
                block
                className = {'continue-btn'}
                clickHandler={() => {
                    updateAuditLoader(true);
                    fetchAuditUrl({
                        cb: (data) => {
                            if(data.data.status == 1) {
                                if(window.top != window.self) {
                                    data.data.url += '&loadedInIframe=true';
                                }
                                window.location.href = data.data.url;
                            } else {
                                alert("No Products Found.");
                            }
                            updateAuditLoader(false);
                        }
                    });
                }}
            >
                {'Start Auditing Now'}
            </Button>
            <Button 
                showLoader = {logoutLoader}
                size="lg"
                block
                variant="default"
                clickHandler={() => {
                    updateLogoutLoader(true);
                    logOut({
                        cb: (data) => {
                            if(data.data.isSuccess){
                                props.setLoggedUser(null);
                                history.push("/login");
                            }
                            updateLogoutLoader(false);
                        }
                    });
                }}
            >
                {'Log Out'}
            </Button>
        </div>
    </div>);
};

const mapStateToProps = state => {
    return {
        auditData: state.products.auditData,
        deviceData: state.deviceData
    };
};

export default connect(mapStateToProps, {setLoggedUser})(AuditSuccess);